import Component from '@bythepixel/component-loader';

export default class SelectedColorOutput extends Component {
  static selector = '[comp-selected-color-output]'

  constructor(...args) {
    super(...args);
    this.$subscribe('option-selector:choose-exterior', ({ exterior }) => {
      if (!exterior) return;
      this.$container.innerText = exterior;
    });
    this.$subscribe('option-selector:preview-exterior', ({ exterior }) => {
      if (!exterior) return;
      this.$container.innerText = exterior;
    });
  }
}
